function SwpieDetect(
	el_target,
	fn_up,
	fn_down,
	fn_left,
	fn_right
) {
	el_target.addEventListener('touchstart', handleTouchStart, false);
	el_target.addEventListener('touchmove', handleTouchMove, false);
	var xDown = null;
	var yDown = null;
	function handleTouchStart(evt) {
	    xDown = evt.touches[0].clientX;
	    yDown = evt.touches[0].clientY;
	};
	function handleTouchMove(evt) {
	    if ( ! xDown || ! yDown ) {
	        return;
	    }

	    var xUp = evt.touches[0].clientX;
	    var yUp = evt.touches[0].clientY;

	    var xDiff = xDown - xUp;
	    var yDiff = yDown - yUp;
	    if(Math.abs( xDiff )+Math.abs( yDiff )>150){ //to deal with to short swipes

	    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
	        if ( xDiff > 0 ) {/* left swipe */
	            // alert('left!');
	            fn_left();
	        } else {/* right swipe */
	            // alert('right!');
	            fn_right();
	        }
	    } else {
	        if ( yDiff > 0 ) {/* up swipe */
	            // alert('Up!');
	            fn_up();
	        } else { /* down swipe */
	            // alert('Down!');
	            fn_down();
	        }
	    }
	    /* reset values */
	    xDown = null;
	    yDown = null;
	    }
	}
	return this;
}
